export interface KpiTileProps {
  label: string;
  value: number | string;
  hint?: string;
}

export default function KpiTile({ label, value, hint }: KpiTileProps) {
  return (
    <div className="kpi-tile">
      <div className="kpi-label">{label}</div>
      <div className="kpi-value">{value}</div>
      {hint && <div style={{ fontSize: '0.75rem', color: 'var(--ion-color-medium)' }}>{hint}</div>}
    </div>
  );
}
